.spinnerContainer {
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
